import Api from '../api';

const resource = '/search';

export default {
  get(code: string, query: string, from: number, size: number) {
    return Api.post(`${resource}`, {
      code,
      query,
      from,
      size,
    });
  },
};
